exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".form-horizontal .control-label[_v-1c8fbd0a]{text-align:left;margin-left:15px}", "", {"version":3,"sources":["/./src/components/Contact.vue"],"names":[],"mappings":"AAmDA,6CAEE,gBAAgB,AAChB,gBAAkB,CACnB","file":"Contact.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.form-horizontal .control-label[_v-1c8fbd0a]{\n  /* text-align:right; */\n  text-align:left;\n  margin-left: 15px;\n}\n"],"sourceRoot":"webpack://"}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./~/vue-loader/lib/style-rewriter.js?id=_v-1c8fbd0a&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./~/eslint-loader!./src/components/Contact.vue
// module id = 328
// module chunks = 0